// extracted by mini-css-extract-plugin
module.exports = {"description":"SubscriptionFormStyle-module--description--2n-Xu","content":"SubscriptionFormStyle-module--content--vfEOY"};